export const genderData = [
  { value: "null", label: "Select" },
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
];

export const GENDER_DATA = [
  { name: "Male", value: "Male" },
  { name: "Female", value: "Female" },
  { name: "Other", value: "Other" },
];
export const LanguagesList = [
  { value: "null", label: "Select" },
  { value: "English", label: "English" },
  { value: "Spanish", label: "Spanish" },
];

export const MAX_FILE_SIZE_MB = 3;

export const ACCEPTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/tiff",
];

export const CaliforniaCities = [
  "Select",
  "Anaheim",
  "Antioch",
  "Bakersfield",
  "Berkeley",
  "Burbank",
  "Carlsbad",
  "Chico",
  "Chula Vista",
  "Clovis",
  "Concord",
  "Corona",
  "Costa Mesa",
  "Daly City",
  "Downey",
  "El Cajon",
  "El Monte",
  "Elk Grove",
  "Escondido",
  "Fairfield",
  "Fontana",
  "Fremont",
  "Fresno",
  "Fullerton",
  "Garden Grove",
  "Glendale",
  "Hayward",
  "Hesperia",
  "Huntington Beach",
  "Inglewood",
  "Irvine",
  "Jurupa Valley",
  "Lancaster",
  "Long Beach",
  "Los Angeles",
  "Menifee",
  "Modesto",
  "Moreno Valley",
  "Murrieta",
  "Norwalk",
  "Oakland",
  "Oceanside",
  "Ontario",
  "Orange",
  "Oxnard",
  "Palmdale",
  "Pasadena",
  "Pomona",
  "Rancho Cucamonga",
  "Rialto",
  "Richmond",
  "Riverside",
  "Roseville",
  "Sacramento",
  "Salinas",
  "San Bernardino",
  "San Diego",
  "San Francisco",
  "San Jose",
  "San Mateo",
  "Santa Ana",
  "Santa Clara",
  "Santa Clarita",
  "Santa Maria",
  "Santa Rosa",
  "Simi Valley",
  "Stockton",
  "Sunnyvale",
  "Temecula",
  "Thousand Oaks",
  "Torrance",
  "Vacaville",
  "Vallejo",
  "Ventura",
  "Victorville",
  "Visalia",
  "West Covina",
];
export const CitiesSelect = CaliforniaCities.map((city) => ({
  value: city,
  label: city,
}));


interface LanguageInterface {
  [key: string]: string;
}

export const Languages: LanguageInterface = {
  en: "English",
  es: "Spanish",
};

export const portableBar = "Portable Bar"
export const iceCubes = "Ice Cubes"